<template>
    <div class="single-product__premium premium-section">
        <div class="single-product__premium-section">
            <div class="single-product__premium-section-slide">
                <div id="premium-section-carousel" class="splide-container splide splide--fade splide--ltr is-active is-overflow is-initialized" role="region" aria-roledescription="carousel">
                    <div class="splide__track splide__track--fade splide__track--ltr" id="premium-section-carousel-track" style="padding-left: 0px; padding-right: 0px;" aria-live="polite" aria-atomic="true" aria-busy="false">
                        <ul class="splide__list" id="premium-section-carousel-list" role="presentation">
                            <li v-for="(item, index) in premiumData" :key="index"  class="splide__slide is-prev" :id="`premium-section-carousel-slide0`+ (index+1)" role="group" aria-roledescription="slide"  style="width: calc(100%); height: 612.938px; transform: translateX(0%); transition: opacity 400ms cubic-bezier(0.25, 1, 0.5, 1);" aria-hidden="true">
                                <template v-if="item.media_type == 'image'">
                                    <img class="d-none d-md-block"
                                        :src="`${baseUrl}api/wp-content/uploads/${item.image_lazy || item.image}`"
                                        :data-original_src="`${baseUrl}api/wp-content/uploads/${item.image}`"
                                        :alt="item.alt ?? ''">

                                    <img class="d-block d-md-none"
                                        :src="`${baseUrl}api/wp-content/uploads/${item.image_mobile_lazy || item.image_mobile || item.image}`"
                                        :data-original_src="`${baseUrl}api/wp-content/uploads/${item.image_mobile || item.image}`"
                                        :alt="item.alt ?? ''">
                                </template>
                                <template v-else>
                                    <video class="master_video has-video d-none d-md-block" muted playsinline loop repeat autoplay>
                                        <source :src="`${baseUrl}api/wp-content/uploads/${item.video}`" :data-src="`${baseUrl}api/wp-content/uploads/${item.video}`" type="video/mp4">
                                    </video>
                                    <video class="master_video has-video d-block d-md-none" muted playsinline loop repeat autoplay>
                                        <source :src="`${baseUrl}api/wp-content/uploads/${item.video_mobile || item.video}`" :data-src="`${baseUrl}api/wp-content/uploads/${item.video_mobile || item.video}`" type="video/mp4">
                                    </video>
                                </template>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- Content with tabs -->
            <div class="single-product__premium-section-content">
                <div class="flex-column">
                    <div class="tabs" :class="premiumData.length === 2 ? 'normal' : ''">
                        <div class="premium-tab" v-for="(item, index) in premiumData" :key="index" :class="index === 0 ? 'active' : ''"  :data-index="index">
                            <span v-html="item.single_tab">

                            </span>
                        </div>
                    </div>
                    <div class="tab-content-box">
                        <div  v-for="(item, index) in premiumData" :key="index" class="tab-content" :class="index === 0 ? 'active' : ''" :id="`tabContent`+index">
                            <h2 style="position: relative;" >
                                {{item.title}}
                                <Sparkle
                                    title="Sparkling Header"
                                    fill="#FFB3C0"
                                    stroke="gray"
                                    :size="50"
                                    :duration="2000"
                                    :pause="200"
                                    v-if="index === currentIndex"
                                />
                                <Sparkle
                                    title="Sparkling Header"
                                    fill="#FFB3C0"
                                    stroke="gray"
                                    :size="23"
                                    :duration="3000"
                                    :pause="200"
                                    v-if="index === currentIndex"
                                />
                            </h2>
                            <p> {{item.content}}</p>
                        </div>
                    </div>

                    <div class="pagination-dots">
                        <span  v-for="(item, index) in premiumData" :key="index" class="dot" :class="index === 0 ? 'active' : ''" @click="changeTab(index)" :data-index="index"></span>
                    </div>
                </div>
            </div>
            <img class="corner-img" src="/single-product/prenium_c.webp" alt="">
        </div>
    </div>
</template>

<style lang="scss">
    @import "@/assets/scss/components/product/_premium.scss";
</style>

<script setup lang="ts">
    import {onMounted, defineProps} from "vue"
    import Splide from "@splidejs/splide"

    import Sparkle from "~/components/Product/SingleProduct/Layouts/Sparkle.vue"

    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;

    interface MediaItem {
        media_type: string;
        image: string | null;
        image_lazy: string | null;
        image_mobile: string | null;
        image_mobile_lazy: string | null;
        video: string | null;
        video_mobile: string | null;
        single_tab: string;
        title: string;
        content: string;
        alt: string | null;
    }

    const props = defineProps<{ data: MediaItem[] }>();

    const premiumData = computed(() =>
        props.data.filter(item => {
            if (item.media_type === "image" && item.image === "") {
                return false;
            }
            if (item.media_type === "video" && item.video === "") {
                return false;
            }
            return true;
        })
    );

    interface PremierItem {
        thumbnail: string;
        type: string;
        menu: string;
        title: string;
        description: string;
    }
    const currentIndex = ref(0);
    const splideInstance = ref<Splide | null>(null);
    const firstLoad = ref(false);
    const updateVideoSrc = () => {
        const videoElement = document.getElementById('master_video2') as HTMLVideoElement | null;
        if (videoElement) {
            const sources = videoElement.querySelectorAll('source');
            sources.forEach((source: any) => {
                if (source.getAttribute('data-src')) {
                source.setAttribute('src', source.getAttribute('data-src'));
                }
            });

            if (videoElement.paused) {
                videoElement.load();
            }
        }
    };
    const handleFirstSlide = () => {
        const firstSlideVideo = document.querySelector('#premium-section-carousel-list .splide__slide:first-child video') as HTMLVideoElement | null;
        if (firstSlideVideo) {
            const sources = firstSlideVideo.querySelectorAll('source');
            sources.forEach((source: any) => {
            if (source.getAttribute('data-src')) {
                source.setAttribute('src', source.getAttribute('data-src'));
            }
            });
            firstSlideVideo.load();
        }
    };
    onMounted(() => {
        altLazyIO();
        handleFirstSlide()
        window.addEventListener('mousemove', (e) => {
            if ( firstLoad.value == false){
                updateVideoSrc()
                firstLoad.value = true;
            }
        });
        if (window.innerWidth < 700) {
            window.addEventListener('touchstart', (e) => {
            if ( firstLoad.value == false){
                updateVideoSrc()
                firstLoad.value = true;
            }
            });
        }
        window.addEventListener('scroll', () => {
            if (firstLoad.value == false) {
                updateVideoSrc();
                firstLoad.value = true;
            }
        });

        const splide = new Splide('#premium-section-carousel', {
            type: 'fade',
            autoplay: true,
            pagination: false,
            heightRatio: 0.75,
            arrows: false,
            interval: 5000,
            pauseOnHover: true,
            drag: false,
            perPage: 1,
            loop: true,
            rewind: true,
            breakpoints: {
                768: {
                    heightRatio: 1,
                }
            }
        });
        splide.on('moved', (newIndex) => {
            const currentSlide = splide.Components.Slides.getAt(newIndex)?.slide;

            if (currentSlide) {
                const videoElement = currentSlide.querySelector('video.has-video');
                if (videoElement) {
                    updateVideoSrc();
                    splide.Components.Autoplay.pause();
                } else {
                    splide.Components.Autoplay.play();
                }
                splide.refresh();
            }
            changeTab(newIndex);
        });

        const premiumTabs = document.querySelectorAll<HTMLElement>('.premium-section .premium-tab');
        premiumTabs.forEach((tab) => {
            tab.addEventListener('click', (e: MouseEvent) => {
                e.preventDefault();
                const index = parseInt((tab as HTMLElement).getAttribute('data-index') || '0', 10);
                splide.go(index);
                splideInstance.value = splide;
                changeTab(index);
            });
        });

        const paginationDots = document.querySelectorAll<HTMLElement>('.premium-section .pagination-dots .dot');
        paginationDots.forEach((dot) => {
            dot.addEventListener('click', (e: MouseEvent) => {
                e.preventDefault();
                const index = parseInt((dot as HTMLElement).getAttribute('data-index') || '0', 10);
                splide.go(index);
                splideInstance.value = splide;
                changeTab(index);
            });
        });

        splide.mount();
    });


    const changeTab = (index: any) => {
        const tabContents = document.querySelectorAll('.premium-section .tab-content');
        const premiumTabs = document.querySelectorAll('.premium-section .premium-tab');
        const dotContents = document.querySelectorAll('.premium-section .dot');

        tabContents.forEach(function(tabContent) {
            tabContent.classList.remove('active');
        });

        premiumTabs.forEach(function(tab) {
            tab.classList.remove('active');
        });

        dotContents.forEach(function(dot) {
            dot.classList.remove('active');
        });

        const selectedTabContent = document.querySelector('.premium-section [id="tabContent' + index + '"]');
        const selectedPremiumTab = document.querySelector('.premium-section .premium-tab[data-index="' + index + '"]');
        const selectedDot = document.querySelector('.premium-section .dot[data-index="' + index + '"]');

        if (selectedTabContent && selectedPremiumTab && selectedDot) {
            selectedTabContent.classList.add('active');
            selectedPremiumTab.classList.add('active');
            selectedDot.classList.add('active');
        }

        currentIndex.value = index;
        if (splideInstance.value) {
            splideInstance.value.Components.Autoplay.pause();
            splideInstance.value.refresh();
        }
    }

</script>
